(() => {
  // app/scripts/common/component/popupComponent.js
  var customElementsName = "popup-component";
  !window.customElements.get(customElementsName) && window.customElements.define(customElementsName, class extends HTMLElement {
    constructor() {
      super();
      this.isOpen = false;
      this.config = {
        activeClass: "active",
        bodyClass: ["show-popup", "overflow-hidden"]
      };
    }
    connectedCallback() {
      this.allCloseElements = this.querySelectorAll(".jsClose");
      if (this.hasAttribute("data-body-class")) {
        this.config.customBodyClass = this.getAttribute("data-body-class").split(",");
      }
      this._handleKeyUp = (e) => {
        e.code == "Escape" && this.isOpen && this.close();
      };
      this._handleResize = () => {
        if (this.isOpen) {
          this.checkVisibility();
        }
      };
      this._handlePopupClose = (e) => {
        if (this.isOpen) {
          this.close();
        }
      };
      document.body.addEventListener("keyup", this._handleKeyUp);
      window.addEventListener("resize", this._handleResize);
      window.addEventListener("popup:close", this._handlePopupClose);
      this.allCloseElements.forEach((el) => el.addEventListener("click", this.handleClose.bind(this)));
      this.autoAppend();
      this.autoShow();
    }
    handleClose() {
      this.close();
    }
    // Add cleanup method
    disconnectedCallback() {
      document.body.removeEventListener("keyup", this._handleKeyUp);
      window.removeEventListener("resize", this._handleResize);
      window.removeEventListener("popup:close", this._handlePopupClose);
      this.allCloseElements.forEach((el) => el.removeEventListener("click", this.handleClose.bind(this)));
      if (this.isHiding) {
        clearTimeout(this.isHiding);
      }
      if (this.isOpen) {
        this.close();
      }
    }
    // Add method to check if popup content is visible
    checkVisibility() {
      const popupContent = this.querySelector(".popup-content");
      if (popupContent) {
        const isVisible = popupContent.clientWidth > 0;
        if (!isVisible) {
          this.close();
        }
      }
    }
    // Add method to check if popup is open
    isPopupOpen() {
      return this.isOpen;
    }
    close() {
      try {
        this.classList.remove(this.config.activeClass);
        if (this.config.customBodyClass)
          document.body.classList.remove(...this.config.customBodyClass);
        const visibilityCheck = () => {
          const isVisible = window.getComputedStyle(this).opacity;
          if (isVisible != "0")
            requestAnimationFrame(visibilityCheck);
          else {
            this.isOpen = false;
            document.querySelectorAll(`.jsTogglePopup[data-control="#${this.id}"]`)?.forEach((el) => el.classList.remove("active"));
            window.dispatchEvent(new CustomEvent("popup:closed", {
              detail: {
                id: this.id,
                popup: this
              }
            }));
            if (Array.from(document.querySelectorAll("popup-component")).some((i) => i.isOpen == true))
              return;
            document.body.classList.remove(...this.config.bodyClass);
          }
        };
        requestAnimationFrame(visibilityCheck);
      } catch (error) {
        console.error("Error closing popup:", error);
      }
    }
    open(callback = null) {
      try {
        window.theme.scrollBarWidth?.();
        this.classList.add(this.config.activeClass);
        document.body.classList.add(...this.config.bodyClass);
        if (this.config.customBodyClass)
          document.body.classList.add(...this.config.customBodyClass);
        const visibilityCheck = () => {
          const isVisible = window.getComputedStyle(this).opacity;
          if (isVisible != "0") {
            this.isOpen = true;
            this.autoHide();
            window.dispatchEvent(new CustomEvent("popup:opened", {
              detail: {
                id: this.id,
                popup: this
              }
            }));
            setTimeout(() => {
              this.querySelector("[autofocus]")?.focus();
            }, 100);
            callback && callback();
          } else {
            requestAnimationFrame(visibilityCheck);
          }
        };
        requestAnimationFrame(visibilityCheck);
      } catch (error) {
        console.error("Error opening popup:", error);
      }
    }
    autoAppend() {
      if (!this.hasAttribute("auto-append"))
        return;
      this.removeAttribute("auto-append");
      const existingNode = document.getElementById(this.id);
      if (existingNode && existingNode !== this) {
        existingNode.after(this);
        existingNode.remove();
      }
    }
    autoShow() {
      if (!this.hasAttribute("auto-show"))
        return;
      this.removeAttribute("auto-show");
      setTimeout(() => {
        this.open();
      }, 300);
    }
    autoHide() {
      if (!this.hasAttribute("auto-hide"))
        return;
      if (this.isHiding != null)
        clearTimeout(this.isHiding);
      this.isHiding = setTimeout(() => {
        this.close();
        this.isHiding = null;
      }, +this.getAttribute("auto-hide"));
    }
  });
})();
